import React from "react";
import { Image } from "../../components/componentIndex";

const Button = ({ btnClass, btnType, btnName, btnImage, btnImgAlt, btnImgCName, onClick, isDisabled }) => {
    return (
        <button className={btnClass} type={btnType} onClick={onClick} disabled={!isDisabled}>
            {btnName === 'Search' ? (
                <>
                    <span className="me-3">{btnName}</span>
                    <Image imgUrl={btnImage} altText={btnImgAlt} className={btnImgCName} />
                </>
            ) : (
                <>
                    <Image imgUrl={btnImage} altText={btnImgAlt} className={btnImgCName} />
                    {btnName}
                </>
            )
            }
        </button>
    );
};

export default Button